import CssEffect from "../../../../src/components/css-effect";
import * as React from 'react';
export default {
  CssEffect,
  React
};